import { render } from "./InmateSearchForm.vue?vue&type=template&id=5b5e88bc&ts=true"
import script from "./InmateSearchForm.vue?vue&type=script&lang=ts"
export * from "./InmateSearchForm.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__